module.exports = __webpack_public_path__ + "img/logo_u1992-9.17c4943f.svg";